module.exports = "/images/no-fee.svg?663d691bbf4f3439648b6620d5f0635b";